import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useDropzone } from 'react-dropzone';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Close from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// core components
import Table from 'components/Table/Table.js';
import EditTable from 'components/Table/EditTable.js';
import Button from "components/CustomButtons/Button.js";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileUpload, faFileDownload } from '@fortawesome/free-solid-svg-icons'

import Confirm from 'views/component/Confirm.js';
import styles from 'views/component/Styles.js';
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";

const useStyles = makeStyles(modalStyle);
const customStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function FacilityList(props) {
    const { testcase, modal, onClose, onTestcaseChange } = props;
    const classes = { ...useStyles(), ...customStyles() };

    // default data
    const [facilityListData, setFacilityListData] = useState([]);
    const [showDrop, setShowDrop] = useState(true);

    // editable table data
    const [facilityListEdit, setFacilityListEdit] = useState({ facilityList: [] });

    // editable toggle
    const [editableFacilityList, setEditableFacilityList] = useState(false);

    // alert
    const [facilityConfirmShow, showFacilityConfirm] = useState(false);
    const noFacility = ['트랙', '분류', '워커', 'RGV'];

    const viewNameSelects = [{ label: '투입기', value: '투입', image: { src: '/GiGAtwinFactory/types/Feeder.png', width: 30 } },
    { label: '절삭기', value: '절삭기', image: { src: '/GiGAtwinFactory/types/model1.png', width: 50 } },
    { label: '프레스기', value: '프레스기', image: { src: '/GiGAtwinFactory/types/model2.png', width: 50 } },
    { label: '검사기', value: '검사기', image: { src: '/GiGAtwinFactory/types/model3.png', width: 50 } },
    { label: '로더', value: '로더', image: { src: '/GiGAtwinFactory/types/loader.png', width: 50 } },
    { label: '언로더', value: '언로더', image: { src: '/GiGAtwinFactory/types/unloader.png', width: 50 } },
    { label: '기타', value: '기타', image: { src: '/GiGAtwinFactory/types/model4.png', width: 50 } }];

    const setModal = function (modal) {
        onClose(modal);
    }

    useEffect(() => {
        if (testcase.testcaseId && testcase.facilityList) {
            const tempList = testcase.facilityList.filter(item => !noFacility.includes(item.modelType));
            setFacilityListData(tempList);
            setEditableFacilityList(false);
            if (tempList.length !== 0) {
                setShowDrop(false);
            }
        }
    }, [testcase]);

    useEffect(() => {
        let temp = [...JSON.parse(JSON.stringify(facilityListData))];
        setFacilityListEdit({ facilityList: temp, removedFacilityList: [] });
    }, [facilityListData]);

    const clickFacilityEditButton = function () {
        let temp = [...JSON.parse(JSON.stringify(facilityListData))];
        setFacilityListEdit({ facilityList: temp, removedFacilityList: [] });
        setEditableFacilityList(true);
    };
    const clickFacilityAddButton = function () {
        let tempData = { ...facilityListEdit };
        tempData.facilityList.push({ name: "", viewName: '', capacity: "", mttr: "", mtbf: "", testcaseId: testcase.testcaseId });
        setFacilityListEdit(tempData);
    };
    const onFacilityChange = function (row, col, value) {
        let tempData = { ...facilityListEdit };
        tempData.facilityList[row][col] = value;
        tempData.facilityList[row].updated = true;
        setFacilityListEdit(tempData);
    };
    const onFacilityRemove = function (row) {
        let tempData = { ...facilityListEdit };
        let removedFacility = tempData.facilityList.splice(row, 1);
        tempData.removedFacilityList = [...tempData.removedFacilityList, removedFacility[0]];
        setFacilityListEdit(tempData);
    };
    const getModelTypeFromViewName = function(name){
        if (['로더', '언로더', '투입', '분배'].includes(name)){
            return name;
        } else {
            return '설비';
        }
    }
    const onFacilityConfirm = function (result) {
        if (result) {
            axios.post('data/facility/listedit',
                {
                    ...facilityListEdit,
                    facilityList: facilityListEdit.facilityList
                        .filter(facility => facility.updated)
                        .map(item => ({ ...item, modelType: getModelTypeFromViewName(item.modelType)}))
                })
                .then(response => {
                    onTestcaseChange();
                    setEditableFacilityList(false);
                });
        }
        showFacilityConfirm(false);
    };

    // 파일 드롭구역
    const onDrop = function (acceptedFiles) {
        acceptedFiles.forEach(file => {
            const reader = new FileReader()

            reader.onload = () => {
                let temp = [];
                reader.result.match(/[^\r\n]+/g).forEach((line, index) => {
                    if (index !== 0) {
                        let tokens = line.split(',');
                        temp.push({
                            testcaseId: testcase.testcaseId, name: tokens[0], viewName: tokens[1], capacity: tokens[2],
                            mtbf: tokens[3], mttr: tokens[4], updated: true, modelType: getModelTypeFromViewName(tokens[1])
                        });
                    }
                });
                const removed = facilityListEdit.facilityList.filter(item => item.facilityId);
                setFacilityListEdit({ ...facilityListEdit, facilityList: temp, removedFacilityList: removed });
                if (temp.length !== 0) {
                    setShowDrop(false);
                    setEditableFacilityList(true);
                }
            }
            reader.readAsText(file, 'euc-kr');
        });

    };

    const onDropRejected = useCallback(() => {
        alert('CSV 파일만 입력 가능합니다');
    }, []);

    const cancelUpload = function (e) {
        e.stopPropagation();
        setShowDrop(false);
    }

    const createDownloadUrl = function (fileName) {
        let base = (axios.defaults.baseURL ? axios.defaults.baseURL : "/GiGAtwinFactory") + "/data/download/";
        return base + testcase.testcaseId + fileName;
    }

    const { getRootProps, getInputProps } = useDropzone({ onDrop, onDropRejected, accept: '.csv' });

    return (
        <Dialog classes={{ root: classes.center, paper: classes.modal }}
            open={modal} transition={Transition} keepMounted fullWidth
            onClose={() => setModal(false)}
            aria-labelledby="modal-slide-title" aria-describedby="modal-slide-description" >
            <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                <Button justIcon className={classes.modalCloseButton} key="close"
                    aria-label="Close" color="transparent" onClick={() => setModal(false)}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>설비정보</h4>
            </DialogTitle>
            <DialogContent id="modal-slide-description" className={classes.modalBody}>
                {showDrop ?
                    <>
                        <div {...getRootProps({ className: 'dropzone' })} className={classes.dropzone}>
                            <input {...getInputProps()} />
                            <div className={classes.dropzoneText}>
                                <div>파일을 드래그하여 업로드하거나<br /> 직접 입력해주세요</div>
                                <Button color="info" onClick={e => cancelUpload(e)}>직접입력</Button>
                            </div>
                        </div>
                    </> : editableFacilityList ? <>
                        <Confirm show={facilityConfirmShow} title="수정 사항 저장" text="수정된 설비 정보를 저장합니다."
                            onConfirm={onFacilityConfirm} confirmText="저장" type='info' />
                        <Button color="danger" className={classes.right} size="sm" onClick={e => { setEditableFacilityList(false); }}>취소</Button>
                        <Button color="info" className={classes.right} size="sm" onClick={e => { showFacilityConfirm(true); }}>저장</Button>
                        <Button color="infoOutline" className={classes.right} size="sm" onClick={clickFacilityAddButton}>추가</Button>
                        <div style={{ clear: 'both' }} />
                        <EditTable
                            tableHeaderColor="primary"
                            tableHead={["이름", '모델 유형', '용량', 'MTBF', 'MTTR']}
                            tableCols={["name", 'viewName', 'capacity', 'mtbf', 'mttr']}
                            tableData={facilityListEdit.facilityList}
                            types={{ capacity: 'number', mtbf: 'number', mttr: 'number' }}
                            underlineColor="info"
                            onChange={onFacilityChange}
                            onRemove={onFacilityRemove}
                            selects={{ viewName: viewNameSelects }}
                        />
                    </> : <>
                            <a download href={createDownloadUrl("/facility.csv")}>
                                <Button justIcon color="infoOutline" className={classes.right} size="sm">
                                    <FontAwesomeIcon icon={faFileDownload} />
                                </Button>
                            </a>
                            <Button justIcon color="infoOutline" className={classes.right} size="sm" onClick={e => { setShowDrop(true); }}>
                                <FontAwesomeIcon icon={faFileUpload} />
                            </Button>
                            <Button color="infoOutline" className={classes.right} size="sm" onClick={clickFacilityEditButton}>수정</Button>
                            <div style={{ clear: 'both' }} />
                            <Table striped
                                tableHeaderColor="primary"
                                tableHead={["이름", '모델 유형', '용량', 'MTBF', 'MTTR']}
                                tableCols={["name", 'viewName', 'capacity', 'mtbf', 'mttr']}
                                tableData={facilityListEdit.facilityList}
                            />
                        </>}
            </DialogContent>
        </Dialog>
    );
}